// @flow
import type { ContractVehiclePlan } from './../types';
import CommonApi from './../commonApi';
const сontractVehiclePlan = new CommonApi<ContractVehiclePlan>(
  'contractVehiclePlan',
  'план НТС'
);
export default сontractVehiclePlan;
